import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "Gilroy-Private",
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "white",
        },
        h1: {
          letterSpacing: "-5px",
          lineHeight: 1,
        },
        h2: {
          letterSpacing: "-4px",
          lineHeight: 1,
          fontSize: 72
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 100,
          fontWeight: 600,
          width: "fit-content",
          boxShadow: "none"
        },
        sizeLarge: {
          padding: "20px 28px"
        },
        sizeMedium: {
          padding: "16px 28px"
        }
      }
    }
  },
  palette: {
    mode: "dark",
    white: {
      main: "#ffffff",
      constastText: "#000000"
    },
    softWhite:{
      main: "#ffffff20",
      contrastText: "#ffffff"
    },
    primary:{
      light: "#9747FF20",
      main: "#9747FF",
      contrastText: "#ffffff"
    }
  }
});

export default theme;